import React, { useContext } from 'react';
import {
  AppContext,
  AppState,
  initialState,
} from '../context/AppContext/context';

type Options = Omit<
  Partial<AppState['confirmationModal']>,
  'status' | 'resolve'
>;

const initialConfirmationModalState = initialState.confirmationModal;

function useConfirm() {
  const { dispatch } = useContext(AppContext);

  const update = React.useCallback(
    (payload: typeof initialConfirmationModalState) => {
      dispatch({
        type: 'SET_CONFIRMATION_MODAL',
        payload,
      });
    },
    [dispatch],
  );

  const onConfirm = React.useCallback(
    async (options?: Options) =>
      new Promise<boolean>(resolve => {
        update({
          ...initialConfirmationModalState,
          ...options,
          status: 'awaiting',
          resolve: (response: boolean) => {
            resolve(response);
            update({
              ...initialConfirmationModalState,
              status: 'resolved',
            });
          },
        });
      }),
    [update],
  );

  return onConfirm;
}

export default useConfirm;
